import { useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import { Menu, Sparkles } from 'lucide-react'
import { Sidebar } from './Sidebar'
import { AssistantPanel } from '../agent'

export function AppShell() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [assistantOpen, setAssistantOpen] = useState(false)

  // The assistant is reachable from every screen, so it gets a global
  // shortcut. Cmd/Ctrl+I — "issue" — and deliberately not Cmd+K, which users
  // expect to be a command palette.
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'i') {
        e.preventDefault()
        setAssistantOpen((open) => !open)
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [])

  const openAssistant = () => {
    setMenuOpen(false)
    setAssistantOpen(true)
  }

  return (
    <div className="app-shell">
      {/* Mobile-only top bar — hamburger opens the sidebar drawer */}
      <div className="mobile-topbar">
        <button
          className="mobile-menu-btn"
          onClick={() => setMenuOpen(true)}
          type="button"
          aria-label="Open menu"
        >
          <Menu size={20} strokeWidth={2} />
        </button>
        <div className="sidebar-brand-icon">×</div>
        <span className="sidebar-brand-text">
          double<span style={{ color: 'var(--accent-primary)' }}>·</span>xl
        </span>
        <button
          className="mobile-menu-btn mobile-topbar__assistant"
          onClick={openAssistant}
          type="button"
          aria-label="Open assistant"
        >
          <Sparkles size={18} strokeWidth={2} />
        </button>
      </div>

      {menuOpen && (
        <div className="sidebar-backdrop" onClick={() => setMenuOpen(false)} aria-hidden="true" />
      )}
      <Sidebar
        open={menuOpen}
        onNavigate={() => setMenuOpen(false)}
        onOpenAssistant={openAssistant}
      />

      <main className="app-main">
        <Outlet />
      </main>

      {assistantOpen && <AssistantPanel onClose={() => setAssistantOpen(false)} />}
    </div>
  )
}
